import { Images } from '../../../utils/imageConstants';

interface MyTeamEmptyStateProps {
  onCreateTeam: () => void;
}

function MyTeamEmptyState({ onCreateTeam }: MyTeamEmptyStateProps) {
  return (
    <div className="myteam-empty-state">
      <div className="myteam-empty-illustration">
        <img src={Images.my_leagues_no} alt="" className="myteam-empty-logo" />
      </div>
      <p className="myteam-empty-message">You haven&apos;t created or joined a team yet.</p>
      <button type="button" className="myteam-empty-cta" onClick={onCreateTeam}>
        Create a team
      </button>
    </div>
  );
}

export default MyTeamEmptyState;
